// extracted by mini-css-extract-plugin
export default {"container":"style--container--84d103","header":"style--header--0cfffc","name":"style--name--5ff1e6","row":"style--row--d3173c"};